import { fetchJson } from 'kanzler.fetch';

/**
 * @typedef {Object} ProductExtraInfo
 * @property {string} id
 * @property {string} elementSectionId
 * @property {string} elementSectionName
 * @property {string} elementSectionPath
 */

/**
 * Fetch catalog data for products
 * @param {string[]} productXmlIds
 * @returns {Promise<ProductExtraInfo[],Error>}
 */
export function fetchExtraProductInfo(productXmlIds) {
    const queryParams = new URLSearchParams();
    productXmlIds.forEach((xmlId) => queryParams.append('product_xml_ids[]', xmlId));

    return fetchJson(`/local/ajax/getExtraProductsInfo.php?${queryParams}`)
        .then(response => response.elements);
}
